var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.889,
    height: 20.01,
    viewBox: "0 0 20.889 20.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-client-3716681",
    transform: "translate(-4.749 -6.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2719",
    "data-name": "Group 2719",
    transform: "translate(5.002 6.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12459",
    "data-name": "Path 12459",
    d: "M39.36,25.511h3.626a1.364,1.364,0,0,0,1.36-1.36V23.7a3.182,3.182,0,0,0-1.7-2.81,2.221,2.221,0,0,0,.793-1.722,2.266,2.266,0,1,0-4.532,0,2.3,2.3,0,0,0,.793,1.722A3.139,3.139,0,0,0,38,23.7v.453A1.364,1.364,0,0,0,39.36,25.511Zm1.813-7.7a1.36,1.36,0,1,1-1.36,1.36A1.364,1.364,0,0,1,41.172,17.806ZM38.906,23.7a2.266,2.266,0,1,1,4.532,0v.453a.455.455,0,0,1-.453.453H39.36a.455.455,0,0,1-.453-.453Z",
    transform: "translate(-30.523 -14.634)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12460",
    "data-name": "Path 12460",
    d: "M25.236,18.457l-.045-.045a2.771,2.771,0,0,0-2.47-.612,7.816,7.816,0,0,0-7.07-10.9,7.766,7.766,0,0,0-7.7,7.818,7.985,7.985,0,0,0,.974,3.807H8.853l-2.719.453a1.336,1.336,0,0,0-1.11,1.564l.77,4.691a1.331,1.331,0,0,0,1.564,1.11l3.4-.566h.181l2.515.589a1.337,1.337,0,0,0,.317.045A.85.85,0,0,0,14,26.387l5.166-.861a1.236,1.236,0,0,0,.793-.453l5.325-6.028A.408.408,0,0,0,25.236,18.457ZM8.853,14.718a6.8,6.8,0,1,1,13.6,0,6.986,6.986,0,0,1-1.767,4.645l-.227.249a7.5,7.5,0,0,1-.929.793,2.684,2.684,0,0,0-2.787-1.314l-3.558.589a.471.471,0,0,1-.249-.023l-2.153-.884a3.181,3.181,0,0,0-.793-.227A6.97,6.97,0,0,1,8.853,14.718Zm10.4,9.812a.42.42,0,0,1-.272.159l-5.144.838h-.181l-2.515-.589a1.53,1.53,0,0,0-.317-.045.85.85,0,0,0-.227.023l-3.4.566a.458.458,0,0,1-.521-.385l-.77-4.691A.379.379,0,0,1,6,20.065a.5.5,0,0,1,.295-.181l2.719-.453a2.8,2.8,0,0,1,1.428.159l2.153.884a1.6,1.6,0,0,0,.725.091l3.558-.589a1.8,1.8,0,0,1,1.949,1.065l-3.308.544a.442.442,0,0,0-.363.521.476.476,0,0,0,.521.385l3.807-.634a.322.322,0,0,0,.136-.045h0a.6.6,0,0,0,.136-.113L22.087,19.2a1.77,1.77,0,0,1,2.2-.34Z",
    transform: "translate(-5.002 -6.9)",
    stroke: "#000",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.59eb89869e7469ac911a49dfac04742e.svg";
export { ForwardRef as ReactComponent };